export const cardsToShowAddCard = 12;
export const videoConversionInProgressStatus = "in_progress";
